module.exports = __webpack_public_path__ + "static/media/coin-to-collect.b2468359.png";